/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PublistMetadata
 */
export interface PublistMetadata  {
    /**
     * 
     * @type {string}
     * @memberof PublistMetadata
     */
    apiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PublistMetadata
     */
    name?: string;
}

/**
 * Check if a given object implements the PublistMetadata interface.
 */
export function instanceOfPublistMetadata(value: object): value is PublistMetadata {
    return true;
}

export function PublistMetadataFromJSON(json: any): PublistMetadata {
    return PublistMetadataFromJSONTyped(json, false);
}

export function PublistMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublistMetadata {
    if (json == null) {
        return json;
    }
    return {
        
                  'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
                  'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PublistMetadataToJSON(json: any): PublistMetadata {
    return PublistMetadataToJSONTyped(json, false);
}

export function PublistMetadataToJSONTyped(value?: PublistMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'apiKey': value['apiKey'],
        'name': value['name'],
    };
}


